import User from '@/pages/components/user';
import { USER } from '@/store/modules/acl-access/constants.ts';

export default [
    {
        name: 'user',
        path: '/user/',
        component: User,
        meta: {
            layout: 'content',
        },
        redirect: { name: 'userLogin' },
        children: [
            {
                name: 'userSettings',
                path: 'settings/',
                component: () => import('@/pages/components/user/settings/index.vue'),
                meta: {
                    section: 'settings',
                    title: (route, { i18n }) => i18n.t('page title user settings'),
                    acl: USER.SETTINGS,
                    breadcrumbs: (route, { i18n }) => ([
                        {
                            label: i18n.t('user.settings.breadcrumb'),
                        },
                    ]),
                },
                redirect: { name: 'userSettingsGeneral' },
                children: [
                    {
                        name: 'userSettingsGeneral',
                        path: 'general/',
                        component: () => import('@/pages/components/user/settings/general.vue'),
                        meta: {
                            title: (route, { i18n }) => i18n.t('user.settings.section.general.title'),
                            acl: USER.SETTINGS,
                            breadcrumbs: (route, { i18n }) => ([
                                {
                                    label: i18n.t('user.settings.section.general.breadcrumb'),
                                },
                            ]),
                        },
                    },
                    {
                        name: 'userSettingsSecurity',
                        path: 'security/',
                        component: () => import('@/pages/components/user/settings/security.vue'),
                        meta: {
                            title: (route, { i18n }) => i18n.t('user.settings.section.security.title'),
                            acl: USER.SETTINGS,
                            breadcrumbs: (route, { i18n }) => ([
                                {
                                    label: i18n.t('user.settings.section.security.breadcrumb'),
                                },
                            ]),
                        },
                    },
                    {
                        name: 'userSettingsPlan',
                        path: 'plan/',
                        component: () => import('@/pages/components/user/settings/plan.vue'),
                        meta: {
                            title: (route, { i18n }) => i18n.t('user.settings.section.plan.title'),
                            acl: USER.SETTINGS,
                            breadcrumbs: (route, { i18n }) => ([
                                {
                                    label: i18n.t('user.settings.section.plan.breadcrumb'),
                                },
                            ]),
                        },
                    },
                    {
                        name: 'userSettingsBilling',
                        path: 'billing/',
                        component: () => import('@/pages/components/user/settings/billing.vue'),
                        meta: {
                            title: (route, { i18n }) => i18n.t('user.settings.section.billing.title'),
                            acl: USER.SETTINGS,
                            breadcrumbs: (route, { i18n }) => ([
                                {
                                    label: i18n.t('user.settings.section.billing.breadcrumb'),
                                },
                            ]),
                        },
                    },
                    {
                        name: 'userSettingsInvites',
                        path: 'invites/',
                        component: () => import('@/pages/components/user/settings/invites.vue'),
                        meta: {
                            title: (route, { i18n }) => i18n.t('user.settings.section.invites.title'),
                            acl: USER.INVITE,
                            breadcrumbs: (route, { i18n }) => ([
                                {
                                    label: i18n.t('user.settings.section.invites.breadcrumb'),
                                },
                            ]),
                        },
                    },
                ],
            },
            {
                name: 'userLogin',
                path: 'login/',
                component: () => import('@/pages/components/user/login.vue'),
                meta: {
                    title: (route, { i18n }) => i18n.t('page title user login'),
                    acl: USER.LOGIN,
                    layout: 'content',
                },
            },
            {
                name: 'userRegister',
                path: 'register/',
                component: () => import('@/pages/components/user/register.vue'),
                meta: {
                    title: (route, { i18n }) => i18n.t('page title user register'),
                    acl: USER.REGISTER,
                    layout: 'content',
                },
            },
            {
                path: 'password/',
                component: () => import('@/pages/components/user/password/index.vue'),
                meta: {
                    layout: 'content',
                },
                redirect: { name: 'userLogin' },
                children: [
                    {
                        name: 'userPasswordForgot',
                        path: 'forgot/',
                        component: () => import('@/pages/components/user/password/forgot.vue'),
                        meta: {
                            title: (route, { i18n }) => i18n.t('page title user password forgot'),
                            acl: USER.FORGOT_PASSWORD,
                            layout: 'content',
                        },
                    },
                    {
                        name: 'userPasswordReset',
                        path: 'reset/:hash/:email',
                        component: () => import('@/pages/components/user/password/reset.vue'),
                        meta: {
                            title: (route, { i18n }) => i18n.t('page title user password reset'),
                            acl: USER.RESET_PASSWORD,
                            layout: 'content',
                        },
                    },
                    {
                        name: 'userPasswordExpired',
                        path: 'expired/:hash/:email',
                        component: () => import('@/pages/components/user/password/expired.vue'),
                        meta: {
                            title: (route, { i18n }) => i18n.t('page title user password expired'),
                            acl: USER.EXPIRED_PASSWORD,
                            layout: 'content',
                        },
                    },
                ],
            },
            {
                name: 'userApprove',
                path: 'approve/:hash?',
                component: () => import('@/pages/components/user/approve.vue'),
                meta: {
                    title: (route, { i18n }) => i18n.t('page title user approve'),
                    acl: USER.APPROVE,
                    layout: 'content',
                },
            },
            {
                name: 'userUnsubscribe',
                path: 'unsubscribe/:hash',
                component: () => import('@/pages/components/user/unsubscribe.vue'),
                meta: {
                    title: (route, { i18n }) => i18n.t('page title user unsubscribe'),
                    acl: USER.UN_SUBSCRIBE,
                    layout: 'content',
                },
            },
            {
                name: 'userThankYou',
                path: 'thank-you',
                component: () => import('@/pages/components/user/thank-you.vue'),
                meta: {
                    title: (route, { i18n }) => i18n.t('page title user thank you'),
                },
            },
            {
                name: 'userTwoFactor',
                path: '2fa',
                component: () => import('@/pages/components/user/two-factor.vue'),
                meta: {
                    title: (route, { i18n }) => i18n.t('page title user two factor'),
                    layout: 'content',
                    acl: USER.TWO_FACTOR,
                },
            },
            {
                name: 'userInvite',
                path: 'invite/',
                component: () => import('@/pages/components/user/invite/index.vue'),
                meta: {
                    layout: 'content',
                },
                redirect: { name: 'userLogin' },
                children: [
                    {
                        name: 'userInviteAccept',
                        path: ':hash/accept',
                        component: () => import('@/pages/components/user/invite/accept.vue'),
                        meta: {
                            title: (route, { i18n }) => i18n.t('page title user invite accept'),
                            layout: 'content',
                        },
                    },
                ],
            },
        ],
    },
];
